import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const ThemeOptionService = {
  get: async () => {
    const response = await apiService.get(`/${slug}/themesoptions`);
    console.log("🚀 ~ getList: ~ response:", response);
    return response.data;
  },

  create: async (data) => {
    const response = await apiService.post(`/${slug}/themesoptions`, data);
    return response.data;
  },
  createKey: async (data) => {
    const response = await apiService.post(`/${slug}/themesoptionkeys`, data);
    return response.data;
  },
  updateKey: async (id, data) => {
    const response = await apiService.put(
      `/${slug}/themesoptionkeys/${id}`,
      data
    );
    return response.data;
  },
  detail: async (id) => {
    const response = await apiService.get(`/${slug}/themesoptions/${id}`);
    return response.data;
  },
  delete: async (id) => {
    const response = await apiService.delete(`/${slug}/themesoptions/${id}`);
    return response.data;
  },
  update: async (id, updatedData) => {
    try {
      const response = await apiService.put(
        `/${slug}/themesoptions/${id}`,
        updatedData
      );
      return response.data;
    } catch (error) {
      console.error("Error updating ratecard:", error);
      throw error;
    }
  },
};

export default ThemeOptionService;
